

































































































import { Component, Vue } from "vue-property-decorator";
import CustomTable from "@/components/table.vue";
import MemberApi from "@/api/admin/member";
import { AdminModel, MemberModel, PaginationModel } from "@/api/types";
import { AdminApi } from "@/api/admin";
import AuthApi from "@/api/auth";
import Encrypt from "@/utils/encrypt";
import moment from "moment";

@Component({
  components: {
    CustomTable,
  },
})
export default class Member extends Vue {
  
  data: MemberModel[] | AdminModel[] = [];
  pagination: PaginationModel & { total?: number } = {
    current: 1,
    pageSize: 10,
    keyword: "",
    keywordType: "name",
  };

  datum: AdminModel = {
    name: "",
    password: "",
  };

  authData = { auth: "" };

  authentificate = false;
  modalLoading = false;
  visible = false;
  adminMode = false;

  memberColumns = [
    // {
    //   width: 100,
    //   title: "순서",
    //   dataIndex: "code",
    // },
    {
      width: 150,
      title: "이름",
      align: "center",
      dataIndex: "name",
      scopedSlots: { customRender: "name" },
    },
    {
      width: 200,
      align: "center",
      title: "전화번호",
      dataIndex: "phone",
      scopedSlots: { customRender: "phone" },
    },
    {
      width: 200,
      align: "left",
      title: "이메일",
      dataIndex: "email",
      scopedSlots: { customRender: "email" },
    },
    {
      width: 200,
      align: "lcenter",
      title: "유전자 검사",
      dataIndex: "",
      scopedSlots: { customRender: "geneApply" },
    },
    {
      width: 200,
      align: "center",
      title: "보유 포인트",
      dataIndex: "",
      scopedSlots: { customRender: "point" },
    },
    // {
    //   width: 200,
    //   align: "center",
    //   title: "성별",
    //   dataIndex: "sex",
    //   scopedSlots: { customRender: "sex" },
    // },
    {
      width: 150,
      align: "center",
      title: "가입일",
      dataIndex: "registerDate",
      scopedSlots: { customRender: "createdTime" },
    },
    // {
    //   width: 100,
    //   align: "right",
    //   title: "동작",
    //   dataIndex: "action",
    //   scopedSlots: { customRender: "action" },
    // },
  ];

  adminColumns = [
    {
      width: 100,
      title: "순서",
      dataIndex: "id",
    },
    {
      width: 150,
      title: "이름",
      dataIndex: "name",
    },
    {
      width: 150,
      align: "right",
      title: "가입일",
      dataIndex: "createdTime",
      scopedSlots: { customRender: "createdTime" },
    },
  ];

  selectItems: KeywordModel[] = [
    {
      value: "name",
      title: "이름",
    },
    {
      value: "phone",
      title: "휴대폰",
    },
    {
      value: "email",
      title: "이메일",
    }
  ];

  send() {
    AuthApi.SendCode();
  }

  dateFormat(date: Date) {
    return moment(date).format("yyyy-MM-DD HH:mm:ss");
  }

  canceled() {
    location.href = "/";
  }

  geneInfo(data: any) {
    console.log("123123");
    let st = "미진행";
    if(data !== null){
      if(data.status == 9){
        st = "완료";
      }else if(data.status == 0){
        st = "대기";
      }else if(data.status == 1){
        st = "진행중";
      } else {
        st = "미진행";
      }
    }
    
    return st;
  } 

  async uploadFile(e:any) {
    let files = e.target.files;
    if(files.length>0){
      let file = files[0];
      console.log(file);

      if (!file.name.match(/(.xlsx)$/)) {
          alert("xlsx 파일만 등록해주세요");
          return;
      }

      let formData = new FormData();
      formData.append('file', file);

      alert("업로드 중입니다. 작업이 완료되면 자동으로 새로고침이되니 잠시만 기다려주세요.");
      const result = await MemberApi.upload(formData);
      alert("작업이 완료되었습니다.");
      location.reload();
      console.log(result);
    }
  }

  async auth() {
    const result = await AuthApi.Auth(this.authData.auth);
    this.authentificate = result.result;
    localStorage.setItem("auth", this.authentificate.toString());
  }

  moveOn(page: any) {
    this.pagination = page;
    this.load();
  }

  search() {
    this.pagination = {
      ...this.pagination,
      current: 1,
    };
    this.load();
  }

  toggle(checked: boolean, _: Event) {
    this.adminMode = checked;
    this.reset();
  }

  reset() {
    this.pagination = {
      ...this.pagination,
      current: 1,
      keyword: "",
      keywordType: "name",
    };
    this.load();
  }

  rowClick(record: any) {
      this.$router.push({ name: "memberDetail", query: { id: record.code , activeKey:"1"} });
  }

  async handleOk() {
    this.modalLoading = true;
    const model: AdminModel = {
      name: this.datum.name,
      password: Encrypt.hash(this.datum.password!),
    };
    await AdminApi.signup(model);
    this.load();
    this.resetDatum();
    this.modalLoading = false;
    this.visible = false;
  }

  handleCancel() {
    this.visible = false;
    this.resetDatum();
  }

  handleChange(value: string) {
    this.pagination.keywordType = value;
  }

  resetDatum() {
    this.datum = {
      id: "",
      name: "",
    };
    this.reset();
  }

  mounted() {
    this.authentificate = localStorage.getItem("auth") === "true";
    this.load();
  }

  async load() {
    let result: any;
    if (this.adminMode) {
      result = await AdminApi.list(this.pagination);
    } else {
      result = await MemberApi.list(this.pagination);
    }
    this.data = [...result.data];
    this.pagination.total = result.totalCount;

    console.log(this.data);
  }

  edit(record: any) {
    this.visible = true;
    this.datum = {
      ...record,
    };
  }

  async remove(record: MemberModel) {
    await MemberApi.delete(record.id!);
    await this.load();
  }

  showModal() {
    this.visible = true;
  }
}

interface KeywordModel {
  value: string;
  title: string;
}
